import React from 'react';
import { Page, Grid, CenterColumnGridCell } from 'styles';
import {
  PerchContainer,
  PerchPageCt,
  StyledUl,
  Title,
  UlListItem,
} from 'pages/perch/perch.style';
import { Text, Button, Icon } from '@perch-labs/shrike';
import confetti from '/images/dashboard-page/confetti.svg';
import perchLogo from '/images/dashboard-page/perch-logo.svg';
import { createGlobalStyle } from 'styled-components';
import { copyFor } from 'config';

const GlobalStyle = createGlobalStyle<{ $whiteColor?: boolean }>`
  *,
*::before,
*::after {
  font-family: 'Manrope', sans-serif !important;
}
`;
export const PerchPage = () => {
  const getCopy = copyFor('perchDashboard');
  const perchHowItWorksUrl =
    'https://www.perchenergy.com/community-solar/how-it-works';
  return (
    <>
      <GlobalStyle />
      <Page maxWidth="auto">
        <Grid width="100%" gap="24px">
          <CenterColumnGridCell>
            <img src={perchLogo} />
            <PerchContainer
              flex
              direction="column"
              alignItems="center"
              justifyContent="center"
              maxWidth="540px"
            >
              <PerchPageCt>
                <img src={confetti} />
                <Title> {getCopy('title')}</Title>
                <Text className="overline">{getCopy('subTitle')}</Text>
                <StyledUl className="ul-item">
                  <UlListItem
                    style={{ color: '#577671', gap: '16px', textAlign: 'left' }}
                  >
                    <Icon
                      scale={2}
                      icon="CheckmarkCircleInverted"
                      color="accent9"
                      style={{ marginTop: '4px' }}
                    />
                    <Text>
                      <span className="bold">
                        {getCopy('listItem.one.msg1')}
                      </span>{' '}
                      {getCopy('listItem.one.msg2')}
                    </Text>
                  </UlListItem>
                  <UlListItem
                    style={{ color: '#577671', gap: '16px', textAlign: 'left' }}
                  >
                    <Icon
                      scale={2}
                      icon="CheckmarkCircleInverted"
                      color="accent9"
                      style={{ marginTop: '4px' }}
                    />
                    <Text>
                      <span className="bold">
                        {getCopy('listItem.two.msg1')}
                      </span>{' '}
                      {getCopy('listItem.two.msg2')}
                    </Text>
                  </UlListItem>
                </StyledUl>

                <Button
                  onClick={() => {
                    location.assign(perchHowItWorksUrl);
                  }}
                >
                  {getCopy('ctaText')}
                </Button>
              </PerchPageCt>
            </PerchContainer>
          </CenterColumnGridCell>
        </Grid>
      </Page>
    </>
  );
};
